import { render, staticRenderFns } from "./AiLeadsPublicTable.vue?vue&type=template&id=c2b3d206&scoped=true"
import script from "./AiLeadsPublicTable.vue?vue&type=script&lang=js"
export * from "./AiLeadsPublicTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b3d206",
  null
  
)

export default component.exports